export default __webpack_public_path__ + "static/media/42.0f609bc4.png";